<template>
  <div>
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item>
        <el-input size="small" v-model="params.name" placeholder="Name" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading"
      element-loading-text="Loading..." style="width: 922px;">
      <el-table-column prop="name" label="Name" width="120" align="center">
      </el-table-column>
      <el-table-column prop="login_time" label="Login Time" width="300">
        <template slot-scope="scope">
          <div>{{scope.row.login_time|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="login_num" label="Login Nums" width="100">
        <template slot-scope="scope">
          <div>{{scope.row.login_num}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="gid" label="Rights Groups" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.g_name}}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="gid" label="是否为商家" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.customer_id>0?'是':'否'}}</div>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="Action">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button v-if="scope.row.id!=1" size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="140px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Name" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="Name" clearable></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input size="small" show-password v-model="editForm.password" auto-complete="off" placeholder="Password"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Confirm Password" prop="conpassword">
          <el-input size="small" show-password v-model="editForm.conpassword" auto-complete="off" placeholder="Confirm Password"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Rights Groups" prop="gid">
          <el-select v-model="editForm.gid" placeholder="Select Rights Groups" clearable>
            <el-option v-for="item in userGroupList" :key="item.id" :label="item.group_name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    systemUserList,
    systemUserSave,
    systemUserDelete,
    systemUserGroupList
  } from '../../api/apiFun'
  import {
    timestampToTime
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制Edit页面显示与隐藏
        title: 'Add',
        editForm: {
          id: '',
          name: '',
          password: '',
          conpassword: '',
          gid: '',
        },
        // rules 表单验证
        rules: {
          name: [{
            required: true,
            message: 'Please enter a name',
            trigger: 'blur'
          }],
          gid: [{
            required: true,
            message: 'Please select Rights Groups',
            trigger: 'blur'
          }],
        },
        params: {
          page: 1,
          limit: 10,
          name: ''
        },
        listData: [], //User数据
        // 选中
        checkmenu: [],
        userGroupList: [],
        //参数role
        saveid: '',
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      }
    },

    created() {
      this.getUserGroupList();
      this.getdata(this.params)
    },

    /**
     * 里面的方法只有被调用才会执行
     */

    methods: {
      // 获取Administrator列表
      getdata(parameter) {
        this.loading = true
        systemUserList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get administrator list, please try again later!')
        })
      },
      // 获取Administrator权限列表
      getUserGroupList(parameter) {
        systemUserGroupList({
          page: 1,
          limit: 100,
          group_name: ''
        }).then(res => {
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.userGroupList = res.datas.list
          }
        }).catch(err => {
          this.$message.error('Failed, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
      //显示Edit界面
      handleEdit: function (index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = 'Edit'
          this.editForm.id = row.id
          this.editForm.name = row.name
          this.editForm.password = ''
          this.editForm.conpassword = ''
          this.editForm.gid = row.gid
        } else {
          this.title = 'Add'
          this.editForm.id = ''
          this.editForm.name = ''
          this.editForm.password = ''
          this.editForm.conpassword = ''
          this.editForm.gid = ''
        }
      },
      // Edit、增加页面Save方法
      submitForm(editData) {
        this.loading = true
        this.$refs[editData].validate(valid => {
          if (valid) {
            systemUserSave(this.editForm).then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.params)
                this.$message({
                  type: 'success',
                  message: 'Saved successfully'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('Saving failed, please try again later!')
            })
          } else {
            return false
          }
        })
      },
      // DeleteAdministrator
      deleteUser(index, row) {
        this.$confirm('Are you sure you want to delete?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          systemUserDelete({
            id: row.id,
            name: row.name,
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'successfully deleted!'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Deletion failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Undelete'
          })
        })
      },
      // closeEdit、增加弹出框
      closeDialog(dialog) {
        if (dialog == 'edit') {
          this.editFormVisible = false
        } else if (dialog == 'perm') {}
      },
    }
  }

</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/system/system_user.vue